var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _config;
var _require = require("../../../consts"),
  TR_BRANDS = _require.TR_BRANDS,
  TR_STATES = _require.TR_STATES,
  SELFIE_FLOW_STATES = _require.SELFIE_FLOW_STATES,
  ONSITE_FLOW_STATES = _require.ONSITE_FLOW_STATES,
  BRAND = _require.BRAND,
  REGION = _require.REGION;
var _require2 = require("../../../utils"),
  getApiBrand = _require2.getApiBrand;
var config = (_config = {
  "APP_URL": "https://czr.gpt.l5y.app",
  "EXTERNAL_SB_API": "https://api.aw.gpt.l5y.app",
  "DIFFUSION_SOCKET": "api.aw.gpt.l5y.app",
  "BET_REFERRAL_SOCKET": "wss://api.aw.gpt.l5y.app",
  "OPEN_BETS_POLL_INTERVAL": 10000,
  "ALL_OPEN_BETS_POLL_FREQUENCY": 3,
  "TETHERED_REG_GEO_POLL_INTERVAL": 30000,
  "DIFFUSION_BASE_URL": "api.aw.gpt.l5y.app",
  "DIFFUSION_CASHOUT_SOCKET": "api.aw.gpt.l5y.app/cashout",
  "DIFFUSION_LIVESCORES_SOCKET": "api.aw.gpt.l5y.app/livescores",
  "PAM_URL": function PAM_URL(state) {
    return "https://api.aw.gpt.l5y.app/pam/".concat(state === 'on' ? 'ca-on' : state, "/api");
  },
  "PAM_BASE_URL": "https://api.aw.gpt.l5y.app/pam",
  "GLOBAL_PAM_BASE_URL": "https://api.aw.gpt.l5y.app/pam",
  "ACCOUNT_CLOSE_URL": "https://api.aw.gpt.l5y.app/caesarscomms/account/close",
  "ALGOLIA_APP_ID": "testing0BNHVHRG0H",
  "ALGOLIA_API_KEY": "9641acd9ab74254550a0bf1575325b33",
  //cms config
  "FEATURE_ANNOUNCEMENT_DATA": "https://eu-cdn.contentstack.com/v3/content_types/feature_anouncements/entries/bltb8588f3f0270a954?environment=testing",
  "FEATURE_ANNOUNCEMENT_DATA_HEADERS": {
    "api_key": "bltacc3c964874661a8",
    "authorization": "cs6f764b1b6f71c31cf4d22d16"
  },
  "CMS_ROOT": "https://cdn.contentstack.io/v3/content_types/",
  "CMS_HEADERS": {
    "api_key": "blt07f2225743220ad0",
    "access_token": "csf8b2ab4be28ec15cd49b3703"
  },
  "CMS_HEADERS_CASINO": {
    "api_key": "blt3ee0cc45db5e2f58",
    "access_token": "csc4d277cd4e027400a88ea25c"
  },
  "CMS_PATH_STATUS_MESSAGE": "app_status_messaging/entries/bltb82d7078fae2addf?environment=testing",
  "CMS_PATH_TETHERED_REG_LOCATIONS": function CMS_PATH_TETHERED_REG_LOCATIONS(state, country, brand) {
    if (state === REGION.PR) {
      return "tetheredreglocation/entries?environment=testing&query={%22apps%22:%22".concat(BRAND.CZR_PR, "%22}");
    } else if (state === REGION["WA-MS"]) {
      return "tetheredreglocation/entries?environment=testing&query={%22apps%22:%22".concat(BRAND.CZR_WA_MS, "%22}");
    } else if (state === REGION.NV && brand === BRAND.CZR) {
      return "tetheredreglocation/entries?environment=testing&query={%22apps%22:%22".concat(BRAND.CZR_NV, "%22}");
    }
    return TR_BRANDS.includes(brand) ? "tetheredreglocation/entries?environment=testing&query={%22apps%22:%22".concat(brand, "%22}") : '';
  },
  "CMS_PATH_TETHERED_ONSITE_COPY": "tethered_registration_onsite_copy/entries?environment=testing",
  "CMS_PATH_CAESARS_REWARDS_EXPERIENCES": "czr_loyalty/entries/blt75b2d045084f17d2?environment=testing",
  "CMS_PATH_CAESARS_REWARDS_TIER_BENEFITS": "czr_loyalty_tier_benefits/entries/bltd444728c056e1636?environment=testing",
  "CMS_PATH_CAESARS_REWARDS_FAQ": "czr_loyalty_faq/entries/blteb40789678674d54?environment=testing",
  "CMS_PATH_CAESARS_REWARDS_ASSETS": "czr_loyalty_assets/entries/blta40cf9bed426d721?environment=testing",
  "CMS_PATH_V3_PROMOS": 'test/entries?environment=testing',
  "CMS_PATH_REGISTRATION_CONFIG": 'registration_config/entries?environment=testing',
  "CMS_PATH_TERMS_OF_SERVICE": 'terms_and_conditions/entries?environment=testing',
  "CMS_PATH_REGISTRATION_COPY": 'registration_copy/entries?environment=testing',
  "CMS_PATH_TOOLTIPS": "sportsbook_tooltip/entries?environment=testing",
  "CMS_PATH_CASINO_CAMPAIGNS": "promotion_v1/entries?environment=test",
  "CMS_PATH_REFERRAL_TERMS": "raf_state_terms/entries?environment=testing",
  //end cms config
  "NEO_API_KEY": "0C88FEE8BCB645F6934657D4A07E5FC7",
  "LOQATE_API_KEY": "AC92-EP43-NY59-EH59",
  "CONTENTSTACK_HELP_PAGES_URL": function CONTENTSTACK_HELP_PAGES_URL(state, country, brand) {
    if (brand === BRAND.CZR_CASINO) {
      return "https://cpo-master.gpt.l5y.app/".concat(state, "/support");
    } else if (brand === BRAND.HORSESHOE) {
      return "https://horseshoe-master.gpt.l5y.app/".concat(state, "/support");
    } else {
      return "https://www.caesars.com/sportsbook-and-casino/".concat(state, "/support");
    }
  },
  "USE_CONTENTSTACK_HELP_PAGES": "true",
  "HELP_URL": "https://help.us.williamhill.com",
  "PTS_BASE_URL": function PTS_BASE_URL(state, country, brand) {
    return "https://api.aw.gpt.l5y.app/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/loyalty/transactions");
  },
  "LOYALTY_BASE_URL": function LOYALTY_BASE_URL(state, country, brand) {
    return "https://api.aw.gpt.l5y.app/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/loyalty");
  },
  "VORAX_URL": "http://us-vorax.aws-us-east-1.gpt.williamhill.plc/event ",
  "VORAX_HEADERS": {
    "api_key": "RKlyPhneWcsbyT1zdShUqn3zr0R9hDcX"
  },
  "ALGOLIA_SEARCH_THROTTLE_TIME_IN_MS": 1500,
  "CASINO_CONTENT_STACK_LOBBY": function CASINO_CONTENT_STACK_LOBBY(state, country, brand) {
    return "https://api.aw.gpt.l5y.app/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/igaming-platform/api/v1/").concat(state);
  },
  "CASINO_CONTENT_STACK_LOBBY_V2": function CASINO_CONTENT_STACK_LOBBY_V2(state, country, brand) {
    return "https://api.aw.gpt.l5y.app/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/igaming-platform/api/v2/").concat(state);
  },
  "CASINO_CONTENT_STACK_BONUS": function CASINO_CONTENT_STACK_BONUS(state, country, brand) {
    return "https://api.aw.gpt.l5y.app/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/bonus-engine/api/v1");
  },
  "CASINO_CONTENT_STACK_BONUS_V2": function CASINO_CONTENT_STACK_BONUS_V2(state, country, brand) {
    return "https://api.aw.gpt.l5y.app/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/bonus-engine/api/v2");
  },
  "CASINO_NETENT_GAME_EVO_JACKPOT_API_URL": function CASINO_NETENT_GAME_EVO_JACKPOT_API_URL(state, country, brand) {
    return "https://api.aw.gpt.l5y.app/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/igaming-platform/api/v1/jackpot");
  },
  "CASINO_NETENT_GAME_EVO_JACKPOT_SUPPLIER_API_GATEWAY": function CASINO_NETENT_GAME_EVO_JACKPOT_SUPPLIER_API_GATEWAY(state, country, brand) {
    return "https://api.aw.gpt.l5y.app/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/suppliers-api-gateway/api/v1/jackpot");
  },
  "DEVICE_DATA_COLLECTOR_URL": "",
  "ALTERNATE_REFERENCE_LENGTH": 12,
  "WSOP_PROMO_URL": function WSOP_PROMO_URL(state) {
    return "https://www.wsop.com/promotions/sports-welcome-offer-vip/".concat(state, "/?sr=2720001&s=").concat(state);
  },
  "AWS_USER_POOL_ID": "us-east-1_XG9zU7apZ",
  "AWS_WEB_CLIENT_ID": "61q0e15ep2dqad8pqaiel6ngkt",
  "BACKGROUND_LIMIT_MINUTES": 240
}, _defineProperty(_config, "DEVICE_DATA_COLLECTOR_URL", "https://test.usc.l5y.app/cdn/cs/EPEAs9wiJIPNMn_gMvC-4RpMrXU.js"), _defineProperty(_config, "AWS_WAF_URL", 'https://4ad3fec456d9.edge.sdk.awswaf.com/4ad3fec456d9/4bccfb2d68a0/challenge.js'), _defineProperty(_config, "AWS_DOMAIN_LIST", ['.williamhill-test.com', '.l5y.app']), _defineProperty(_config, "AWS_CAPTCHA_URL", 'https://4ad3fec456d9.edge.captcha-sdk.awswaf.com/4ad3fec456d9/jsapi.js'), _defineProperty(_config, "AWS_CAPTCHA_API_KEY", 'kD3l6kk/O8ZF/YorwKqmgmhJD3RXoLbDli6Id5/NxWrEeWA5iHywLO0RpoqsLXGd6ldpFUDGU6w8CUCLsSRgd3oChDHd8zQUrJoKjEFwZGtDJx3aNSXGZl8MeMqFCDpuJ4j07FGZ5io824vPUlSS+DrZl0YD004PnKFEGqEpjScU8GjPqnmmhX1had2lj2mNASvt2NUQiEbbmzJ0eAZEvB/pe8W6yjmaL9LXysS8gY8oGTtEJKqKgZFUtm6WexI1YhpRLsSPw0zQciqjCnv2BDRju6iJOHMPAohf8qCcjmMPwp9z+PMcJFPMG8sygIeCyD4Y24GDefH7X653dPkIEZNJdqwbT/qQCBZX+pJjaSI+mhwuOhswJz+m/Kyb0M2kHMD9emP+F1rMDeNrOS6PDdGovhBNutsasMju4feLfEGmXevzUgS7vV33eAnHEESe48cg4/4Jd+YFynCDVzqkdBEjK1po7aPKl+k6+CPlwp4UHncTVC6gDNTqbArM6+Hue6Aj4dYG6n4y0LN5yQtsVV2O4iXJUBUP2z01O/jhI1WHJKynTZp6ZlYJlLb+O72pp6mluR++NGAgicAODeSnATbkcQo/FHfkaMuVi6o9BB6EkP3L1S/ckGg6W5MLKIhwz/4XTDfr+Tk/wIP4YgWZsxKAz8FYvPSDCMXLJd+mSc4=_1_1'), _defineProperty(_config, "TRANSACTION_HISTORY", function TRANSACTION_HISTORY(state, country, brand) {
  return "https://api.aw.gpt.l5y.app/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/sb/v3/transaction-history");
}), _defineProperty(_config, "TAX_REPORT_W2G", function TAX_REPORT_W2G(state, country, brand) {
  return "https://api.aw.gpt.l5y.app/regions/".concat(country, "/locations/").concat(state, "/brands/").concat(getApiBrand(brand), "/igaming/transaction-history/api/v1/tax/report/");
}), _defineProperty(_config, "RAF_API_URL", "https://api.aw.gpt.l5y.app/rfp/api/v1"), _defineProperty(_config, "KYC", "NEO"), _defineProperty(_config, "KYC_POLL_INTERVAL", 35000), _defineProperty(_config, "TRENDING_BETS_CONFIG", {
  "numberOfLegs": 6,
  "betTypes": 'BYO',
  "byEvent": {
    "numberOfLegs": 6,
    "betTypes": ['BYO'],
    "numberOfBets": 5,
    "sortBy": 'odds',
    "order": 'desc'
  },
  "makeItAParlay": {
    "numberOfLegs": 4,
    "betTypes": [],
    "numberOfBets": 4
  }
}), _defineProperty(_config, "TR_STATES", TR_STATES), _defineProperty(_config, "SELFIE_FLOW_STATES", SELFIE_FLOW_STATES), _defineProperty(_config, "ONSITE_FLOW_STATES", ONSITE_FLOW_STATES), _defineProperty(_config, "REGISTRATION_CONFIG", {
  "USE_THREAT_METRIX": false,
  "SHOW_RG_LIMITS": false,
  "USE_PROMO_APPLIED_BANNER": false,
  "USE_TERMS_OF_SERVICE_CHECKBOX": false,
  "DIRECT_MARKETING": false
}), _defineProperty(_config, "NEW_RELIC", function NEW_RELIC(state, country, brand) {
  switch (brand) {
    // czr-casino-gpt
    case 'czr-casino':
      return {
        accountID: "3213452",
        agentID: "594478063",
        applicationID: "594478063",
        licenseKey: "NRJS-e669ccdccb3105827d7",
        trustKey: "2185826"
      };
    // horseshoe-gpt
    case 'horseshoe':
      return {
        accountID: "3213452",
        agentID: "594477132",
        applicationID: "594477132",
        licenseKey: "NRJS-e669ccdccb3105827d7",
        trustKey: "2185826"
      };
    // sportsbook-wh-gpt
    case 'wh':
      return {
        accountID: "3213452",
        agentID: "594478076",
        applicationID: "594478076",
        licenseKey: "NRJS-e669ccdccb3105827d7",
        trustKey: "2185826"
      };
    // All CZR apps reports to the same GPT application (sportsbook-czr-gpt)
    case 'czr':
    case 'czr-pr':
    case 'czr-ms':
    case 'czr-wa-ms':
      return {
        accountID: "3213452",
        agentID: "594478085",
        applicationID: "594478085",
        licenseKey: "NRJS-e669ccdccb3105827d7",
        trustKey: "2185826"
      };
  }
}), _config);
module.exports = config;